import useRegistrationContext from "../../../../hooks/useRegistrationContext";
import PersonalInformation from "./PersonalInformation";
import ContactInformation from "./ContactInformation";
import MembershipStatus from "./MembershipStatus";
import RegionConstituency from "./RegionConstituency";
import EducationBackground from "./EducationBackground";
import ProfessionOccupation from "./ProfessionOccupation";
import Confirmation from "./Confirmation";

const RegistrationFormInputs = () => {
	const { page } = useRegistrationContext();

	const display = {
		0: <MembershipStatus />,
		1: <PersonalInformation />,
		2: <ContactInformation />,
		3: <RegionConstituency />,
		4: <EducationBackground />,
		5: <ProfessionOccupation />,
		6: <Confirmation />,

	};

	const content = <div className="form-inputs flex-col">{display[page]}</div>;

	return content;
};
export default RegistrationFormInputs;
